import cancelImage from "@images/popups/cancel-upload.svg";
import {SmallDesc} from "@ui/descriptions/SmallDesc";

import styles from "./styles.module.scss";

export const DocumentPreview = ({level, name, onClickCross}) => {
  return (
    <SmallDesc>
      <span className={styles.docPreview}>
        {name}

        {onClickCross && (
          <img
            onClick={() => onClickCross(name, level)}
            src={cancelImage}
            alt={"remove"}
          />
        )}
      </span>
    </SmallDesc>
  );
};
